import type { LucideIcon } from "lucide-react";
import type { MediaAsset } from "../types/content";
import { ResponsiveImage } from "./ResponsiveImage";

export interface AreaStat {
  icon: LucideIcon;
  value: string;
  label: string;
}

interface AreaHeroProps {
  title: string;
  accent: string;
  lead: string;
  meta: string;
  media: MediaAsset;
  stats: AreaStat[];
}

export function AreaHero({ title, accent, lead, meta, media, stats }: AreaHeroProps) {
  return (
    <section className="area-hero">
      <div className="area-hero__media" aria-hidden="true">
        <ResponsiveImage media={media} alt="" priority sizes="100vw" />
      </div>
      <div className="area-hero__wash" aria-hidden="true" />
      <div className="shell area-hero__content">
        <div className="area-hero__copy">
          <h1>{title} <span>{accent}</span></h1>
          <p>{lead}</p>
          <small>{meta}</small>
        </div>
        <div className="area-hero__stats" aria-label="Resumo da área">
          {stats.map(({ icon: Icon, value, label }) => (
            <div key={label}>
              <Icon aria-hidden="true" />
              <span><strong>{value}</strong><small>{label}</small></span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
